export const SET_TRANSCRIPT_CONVERSATION_LOADER =
  'SET_TRANSCRIPT_CONVERSATION_LOADER';
export const TRANSCRIPT_CONVERSATION = 'TRANSCRIPT_CONVERSATION';
export const AGENT_INFORMATION = 'AGENT_INFORMATION';
export const GET_TRANSCRIPT_DEPLOYMENT = 'GET_TRANSCRIPT_DEPLOYMENT';
